import React, { useState } from 'react';
import { useFormik } from 'formik';
import PhoneInput from 'react-phone-input-2';
import * as Yup from 'yup';
import 'react-phone-input-2/lib/style.css';
import axios from 'axios';
import config from '../config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ContactSection = ({ countryCode }) => {
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const validationSchema = Yup.object({
    contact_name: Yup.string()
      .trim()
      .required('Full Name is required.'),
    contact_email: Yup.string()
      .email('Please enter a valid email address.')
      .required('Email Address is required.'),
    contact_phone: Yup.string()
      .trim()
      .required('Phone number is required.'),
    contact_message: Yup.string()
      .trim()
      .required('Message is required.'),
  });

  const {
    values,
    errors,
    touched,
    handleChange,
    handleSubmit,
    setFieldValue,
    isSubmitting,
    resetForm,
  } = useFormik({
    initialValues: {
      contact_name: '',
      contact_email: '',
      contact_phone: '',
      contact_message: '',
    },
    validationSchema,
    onSubmit: async (values) => {
      const api = config.apiBaseUrl;
    
      const requestBody = {
        contact_name: values.contact_name,
        contact_email: values.contact_email,
        contact_phone: '+'+values.contact_phone,
        contact_message: values.contact_message,
      };
      try {
        const response = await axios.post(`${api}contact-us/`, requestBody);
        if (response.data && response.data.status === 1) {
          resetForm();
          toast.success(response.data.message || 'Thank you for contacting us.! We will get back to you soon.');
        } else {
          toast.error(response.data.message || 'Something went wrong! Please try again.');
        }
      } catch (error) {

        toast.error('Something went wrong! Please try again.');
      }
    }   
  });

  // Country-specific phone numbers
  const phoneNumber =
    countryCode === 'IN' ? '+91-7218913425' : '+1-(512) 203-7627';

  return (
    <section className="section-white section-top-border" id="contact">
           <ToastContainer />
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h4>Get in touch</h4>
            {submitSuccess && (
              <p className="contact_success_box">
                We received your message and you'll hear from us soon. Thank you!
              </p>
            )}
            <form onSubmit={handleSubmit}>
              <div className="input-margin">
                <input
                  className="contact-input white-input"
                  name="contact_name"
                  placeholder="Full Name*"
                  value={values.contact_name}
                  onChange={handleChange}
                />
                {touched.contact_name && errors.contact_name && (
                  <span className="text-danger">{errors.contact_name}</span>
                )}
              </div>
              <div className="input-margin">
                <input
                  className="contact-input white-input"
                  name="contact_email"
                  placeholder="Email Address*"
                  value={values.contact_email}
                  onChange={handleChange}
                />
                {touched.contact_email && errors.contact_email && (
                  <span className="text-danger">{errors.contact_email}</span>
                )}
              </div>
              <div className="input-margin">
                <PhoneInput
                  country={countryCode === 'IN' ? 'in' : 'us'}
                  preferredCountries={
                    countryCode === 'IN' ? ['in', 'us', 'gb'] : ['us', 'in', 'gb']
                  }
                  value={values.contact_phone}
                  onChange={(phone) => setFieldValue('contact_phone', phone)}
                  inputStyle={{
                    width: '100%',
                    fontSize: '16px',
                    height: '45px',
                    color: '#656565',
                    border: '1px solid #ededed',
                  }}
                  containerStyle={{
                    marginBottom: '10px',
                  }}
                />
                {touched.contact_phone && errors.contact_phone && (
                  <span className="text-danger">{errors.contact_phone}</span>
                )}
              </div>
              <div className="input-margin">
                <textarea
                  className="contact-comment white-input"
                  name="contact_message"
                  placeholder="Your Message*"
                  rows="2"
                  cols="20"
                  value={values.contact_message}
                  onChange={handleChange}
                />
                {touched.contact_message && errors.contact_message && (
                  <span className="text-danger">{errors.contact_message}</span>
                )}
              </div>
              <div className="input-margin">
                <input
                  type="submit"
                  className="register-submit"
                  id="submit-button"
                  disabled={isSubmitting}
                  value={isSubmitting ? 'Submitting...' : 'Send Message'}
                />
                {isSubmitting && <span id="submit-spinner" className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
              </div>
            </form>
          </div>
          <div className="col-md-6">
            <h4>How to find us</h4>
            <h5>Interested in Partnership</h5>
            <p className="contact-info">
              <i className="fas fa-envelope mr-10"></i>
              <a href="mailto:hello@instaapp.online" target="_top" rel="noopener noreferrer">
                hello@instaapp.online
              </a>
            </p>
            <p className="contact-info">
              <i className="fas fa-phone fa-flip-horizontal mr-10"></i>
              <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </p>
            {countryCode === 'IN' && (
              <p className="contact-info">
                <i className="fas fa-map-marker-alt mr-10"></i> City Avenue, Oppo. Phoenix Mall of the Millennium,
                <br />
                <span className="ml-30">Mumbai-Bangalore Highway, Wakad, Pune 411057</span>
              </p>
            )}
            <br />
            <br />
            <h5>Interested in contacting Customer Service</h5>
            <p className="contact-info">
              <i className="fas fa-envelope mr-10"></i>
              <a href="mailto:support@instaapp.online" target="_top" rel="noopener noreferrer">
                support@instaapp.online
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
